module.exports = __webpack_public_path__ + "img/antes_despues_148.fd16c588.png";